import request from "@/CommonDP/utils/request";
// revit导出设置接口
export default {
  getDicList(dicCode) {
    return request.get(`/dic/content/list?dicCode=${dicCode}`);
  },

  saveRightTables(params) {
    return request.post(`/revitExportSettings/conf/detail/add`, params);
  },

  // 1.	获取专业
  getProfessionalList(enterpriseId) {
    return request.get(`/standardLayer/getProfessionalList?enterpriseId=${enterpriseId}`);
  },
  // 4.	管道系统图层设置/风管系统图层设置/电缆桥架图层设置 固定目录调用
  getRevitSettingsDicList() {
    return request.get(`/revitExportSettings/conf/dicList`);
  },
  // 4.	管道系统图层设置/风管系统图层设置/电缆桥架图层设置 固定目录调用
  getRevitSettingsList(ruleId) {
    return request.get(`/revitExportSettings/conf/detail/list?ruleId=${ruleId}`);
  },
  // 根据专业获取图层
  getCategoriesList(enterpriseId, dicCode) {
    return request.get(`/revitExportSettings/ruleSettingsDetails/categoriesList?enterpriseId=${enterpriseId}&dicCode=${dicCode}&pageNum=1&pageSize=0`);
  },
  // 获取规则设置左侧数据
  getRuleLeftData(enterpriseId) {
    return request.get(`/revitExportSettings/conf/list?enterpriseId=${enterpriseId}`);
  },
  // 添加规则设置左侧
  addRuleSetLeft(params) {
    return request.post("/revitExportSettings/conf/add", params);
  },
  // 删除规则设置左侧
  deleteRuleSetLeft(ruleId) {
    return request.get(`/revitExportSettings/conf/delete?ruleId=${ruleId}`);
  },
  // 复制规则设置左侧
  copyRuleSetLeft(params) {
    return request.post("/revitExportSettings/ruleSettings/copy", params);
  },
  // 编辑规则设置左侧
  editRuleSetLeft(params) {
    return request.post("/revitExportSettings/conf/rename", params);
  },

  // 获取规则设置右侧数据
  getRuleRight(ruleId) {
    return request.get(`/revitExportSettings/ruleSettingsDetails/list?ruleId=${ruleId}`);
  },
  // 获取规则设置右侧字典
  getRuleRightDicList() {
    return request.get("/revitExportSettings/ruleSettingsDetails/dicList");
  },
  // 图层列表
  getLayerList(params) {
    return request.get("/revitExportSettings/ruleSettingsDetails/categoriesList", { params });
  },
  // 获取线型列表
  getLinearList(enterpriseId) {
    return request.get(`/linear/getLinearList?enterpriseId=${enterpriseId}`);
  },
  // 添加规则设置右侧
  addRuleSetRight(params) {
    return request.post("/revitExportSettings/ruleSettingsDetails/add", params);
  },
  // 修改规则设置右侧
  editRuleSetRight(params) {
    return request.post("/revitExportSettings/ruleSettingsDetails/update", params);
  },
  // 删除规则设置列表
  deleteRuleSetList(array) {
    return request.post("/revitExportSettings/ruleSettingsDetails/delete", array);
  },
  // 移动规则设置右侧 1=上移，2=下移，3=置顶，4=置底
  moveRuleSetRight(params) {
    return request.get("/revitExportSettings/ruleSettingsDetails/move", { params });
  },
  // 下载规则模板
  downloadRuleTemplate() {
    return request({
      url: `/revitExportSettings/ruleSettingsDetails/downloadTemplate`,
      method: "get",
      responseType: "blob",
    });
  },
  // 导出配置,规则设置
  exportRuleSet(ruleId) {
    return request({
      url: `/revitExportSettings/ruleSettingsDetails/export?ruleId=${ruleId}`,
      method: "get",
      responseType: "blob",
    });
  },
  // 导入配置,规则设置
  importRuleSet(data) {
    return request.post("/revitExportSettings/ruleSettingsDetails/import", data, {
      timeout: 0,
    });
  },
  // 规则下载失败列表
  downloadRuleFailList(params) {
    return request({
      responseType: "blob",
      url: "/revitExportSettings/ruleSettingsDetails/downloadFailList",
      method: "post",
      data: params,
    });
  },

  // 获得字体设置左侧数据
  getFontLeftData(enterpriseId, type) {
    return request.get(`/revitExportSettings/fontStyleSettings/list?enterpriseId=${enterpriseId}&type=${type}`);
  },
  // 添加字体设置左侧
  addFontSetLeft(params) {
    return request.post("/revitExportSettings/fontStyleSettings/add", params);
  },
  // 删除字体设置左侧
  deleteFontSetLeft(fontStyleId) {
    return request.get(`/revitExportSettings/fontStyleSettings/delete?fontStyleId=${fontStyleId}`);
  },
  // 复制字体设置左侧
  copyFontSetLeft(params) {
    return request.post("/revitExportSettings/fontStyleSettings/copy", params);
  },
  // 编辑字体设置左侧
  editFontSetLeft(params) {
    return request.post("/revitExportSettings/fontStyleSettings/rename", params);
  },
  // 修改字体设置左侧
  updateFontSetLeft(params) {
    return request.post("/revitExportSettings/fontStyleSettings/update", params);
  },

  // 获取字体设置右侧数据
  getFontRightData(fontStyleId) {
    return request.get(`/revitExportSettings/fontStyleSettingsDetails/list?fontStyleId=${fontStyleId}`);
  },
  // 添加字体设置右侧
  addFontSetRight(params) {
    return request.post("/revitExportSettings/fontStyleSettingsDetails/add", params);
  },
  // 修改字体设置右侧
  editFontSetRight(params) {
    return request.post("/revitExportSettings/fontStyleSettingsDetails/update", params);
  },
  // 删除字体设置列表
  deleteFontSetList(array) {
    return request.post("/revitExportSettings/fontStyleSettingsDetails/delete", array);
  },
  // 下载字体模板
  downloadFontTemplate() {
    return request({
      url: `/revitExportSettings/fontStyleSettingsDetails/downloadTemplate`,
      method: "get",
      responseType: "blob",
    });
  },
  // 导入字体样式
  importFontSet(data) {
    return request.post("/revitExportSettings/fontStyleSettingsDetails/import", data, {
      timeout: 0,
    });
  },
  // 导出配置,字体设置
  exportFontSet(fontStyleId) {
    return request({
      url: `/revitExportSettings/fontStyleSettingsDetails/export?fontStyleId=${fontStyleId}`,
      method: "get",
      responseType: "blob",
    });
  },
  // 字体样式下载失败列表
  downloadFontFailList(params) {
    return request({
      responseType: "blob",
      url: "/revitExportSettings/fontStyleSettingsDetails/downloadFailList",
      method: "post",
      data: params,
    });
  },
};
